import { css } from "@emotion/react";
import { useMemo } from "react";
import { FeedbackDesign } from "../types/feedback.types";
import { cssForFont } from "./fontUtils";

function useFeedbackStyles(design?: FeedbackDesign) {
  return useMemo(() => {
    if (!design) return null;
    const { primaryColor, backgroundColor, paperColor, customCSS, questionColor, fonts, fontFamily = "arial" } = design;

    return css([
      { backgroundColor },
      { ".wrapper": { backgroundColor: paperColor, fontFamily } },
      fonts && cssForFont(fonts),
      `

        h3 {
          color: ${primaryColor};
          font-weight: 500;
        }
        .button {
            background-color: ${primaryColor};
            border-color: ${primaryColor};
        }
      
        .feedback-label {
          color: ${questionColor || "#444"}
        }
      
        ${customCSS || ""}`,
    ]);
  }, [design]);
}

export default useFeedbackStyles;
